import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { AgeRateFilterInterceptor } from './age-rate-filter.interceptor';
import { KidsProfileFilterInterceptor } from './kids-profile-filter.interceptor';
import { PlayerAndPersonaMpxService } from './player-and-persona-mpx.service';

@NgModule({
  imports: [CommonModule],
  providers: [
    PlayerAndPersonaMpxService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: KidsProfileFilterInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AgeRateFilterInterceptor,
      multi: true,
    },
  ],
})
export class MpxModule {}
